import { createContext, useContext } from 'react'

import { UIStore } from './UIStore'

export const UIContext = createContext<UIStore | undefined>(undefined)

export function useUIStore(): UIStore {
  // @ts-expect-error TS(2322) FIXME: Type 'UIStore | undefined' is not assignable to ty... Remove this comment to see the full error message
  const uiStore: UIStore = useContext(UIContext)
  if (!uiStore) {
    throw new Error('Must use useUiStore within an UIContext')
  }
  return uiStore
}
